import React, { Fragment, useEffect, useState } from "react";
import HeroBanner from "../component/Common Banner Component/HeroBanner"
import IdvBlogSec from "../component/IdvBlogSec/IdvBlogSec"
import Footer from '../component/Footer/Footer'
import { useParams } from "react-router";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "../component/Header/Header";
import { blogData } from "./BlogsData";

function BlogInner() {

  const [blogsData, setBlogsData] = useState();
  const [catagory, setCatagory] = useState("Genral");
  const [recentBlogs, setRecentBlogs] = useState([]);

  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  

  let blogAPICalledId = false;
  let allBlogsCalled = false;

  const getAllBlogs = async () => {
    if (allBlogsCalled) return;
    allBlogsCalled = true;

    setLoading(true);
    axios
      .get(`/blogs`, {})
      .then((res) => {
        if (res.data.status === "success") {
          let Updated_recent_blogs = [];
          let blog = res.data.data.find((item) => item.slug_url == id);
          setBlogsData(blog);

          res.data.data.forEach((item) => {
            Updated_recent_blogs.push({
              id: item.blog_id,
              slug_url: item.slug_url,
              logo: item.blog_image,
              blog_description: item.title,
              date: item.published_date,
            });
          });
          setRecentBlogs(Updated_recent_blogs.slice(0, 3));

          setLoading(false)

          // axios.get(`/api/categories/catagory/${blog.category}`).then((result)=>{
          //   if(result.data.status == "success")
          //   {
          //     console.log("data",result.data);
          //     setCatagory(result.data.data.category)
          //     setLoading(false)
          //   }
          //   else{
          //     setLoading(false)
          //   }
          // })
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err");
        setBlogsData(null)
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllBlogs();
  }, [id]);


  const popularBlogDate = [
    {
      logo:"/images/icons/blog-card-thumbnail.png",
      blog_description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "Apr 10, 2023",
      slug_url:"bloginner"
    },
    {
      logo:"/images/icons/blog-card-thumbnail.png",
      blog_description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "Apr 10, 2023",
      slug_url:"bloginner"
    },
    {
      logo:"/images/icons/blog-card-thumbnail.png",
      blog_description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "Apr 10, 2023",
      slug_url:"bloginner"
    },
    
  ];

  return (
    <>
    {loading  ? (
          <div
            style={{ width: "100%", height: "100vh" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Spinner
              style={{ color: "black", width: "120px", height: "120px" }}
            />
          </div>
        ) : (
          <>
            <Helmet>
              {blogsData?.metaTitle && <title>{blogsData.metaTitle}</title>}
              {blogsData?.metaDescription && <meta name='description' content={blogsData.metaDescription} />}
              {blogsData?.canonicalLink && <link rel="canonical" href={blogsData.canonicalLink}></link>}
            </Helmet>
            {/* <HeroBanner 
              subHeading=""
              // Heading={blogsData.title}
              Heading={"Blog Heading"}
              nextLineSpanHeading=""
              Paragraph={`By: Mobile Lazer Therapy | Published On:  02 Feb 2025 `}
              btn={false}
              bgImg="/images/creatives/plain-hero-bg.png"
              heightAuto={true}
            /> */}

        <div>
                <div style={{position:"relative",zIndex:"1"}}>

                <Header/>
                </div>
                <div className='plain-hero d-flex flex-column align-items-center justify-content-center' >

                    <h4 className='body-heading' style={{color:"white",textShadow:"1px white"}}>{blogsData?.title}</h4>
                    <p className='body-paragraph' style={{color:"white",textShadow:"1px white"}}> By: Mobile Laser Therapy | Published On:  {blogsData?.published_date}</p>

                </div>
              <div className="d-flex w-100">

              {/* <img src="/images/icons/blog-card-thumbnail.png" alt="blog thumbnail" style={{transform:"translateY(-50px)"}} className="mx-auto" /> */}
              </div>
              </div>
            <IdvBlogSec
              blogsData={blogsData?.blogs_content}
              text={blogsData?.brief_paragraph}
              img={blogsData?.blog_image}
            />
            <Footer 
      newsletterSection={false}
    />
          </>
        )}
    </>
  )
}

export default BlogInner